type PresaleModalOpenSetter = (isOpen: boolean) => void;

let setPresaleModalOpen: PresaleModalOpenSetter | null = null;

export const registerPresaleModalOpenSetter = (setter: PresaleModalOpenSetter | null): void => {
  setPresaleModalOpen = setter;
};

export const openPresaleModal = (): void => {
  setPresaleModalOpen?.(true);
};

export const closePresaleModal = (): void => {
  setPresaleModalOpen?.(false);
};
